import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, isDevMode, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterOutlet } from '@angular/router';
import Bugsnag from '@bugsnag/js';
import { environment } from '../environments/environment';
import { AppRoutesModule } from './app.routes.module';
import { AppComponent } from './app.component';
import { AppStartup } from './app.startup';
import { SaleModule } from './sale/sale.module';
import { UsersService } from './shared/services/users.service';
import { CURRENT_USER } from './shared/tokens/current-user';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import { AuthInterceptor } from './admin/interceptors/auth.interceptor';

Bugsnag.start({
    apiKey: '3f3a563430136077798b204b962a3f93',
    releaseStage: environment.env,
    autoTrackSessions: false,
});

Bugsnag.startSession();

class AppErrorHandler implements ErrorHandler {
    public handleError(error: Error): void {
        const isRouteNotFound =
            error.message.includes('Cannot match any routes') ||
            (error as { code?: string }).code === 'NG04002';

        if (!isDevMode() && !isRouteNotFound) {
            Bugsnag.notify(error);
        }

        console.error(error);
    }
}

@NgModule({
    bootstrap: [AppComponent],
    declarations: [AppComponent],
    imports: [
        CommonModule,
        BrowserAnimationsModule,
        BrowserModule,
        RouterOutlet,
        HttpClientModule,
        MatButtonModule,
        MatMenuModule,
        SaleModule,
        AppRoutesModule,
        NgxGoogleAnalyticsModule.forRoot(environment.googleAnalyticsTrackingId),
        NgxGoogleAnalyticsRouterModule,
    ],
    providers: [
        {
            deps: [AppStartup],
            multi: true,
            provide: APP_INITIALIZER,
            useFactory: (startup: AppStartup) => () => startup.init(),
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        {
            deps: [UsersService],
            multi: false,
            provide: CURRENT_USER,
            useFactory: (users: UsersService) => users.current(),
        },
        { provide: ErrorHandler, useClass: AppErrorHandler },
        provideCharts(withDefaultRegisterables()),
    ],
})
export class AppModule {
    //
}
